// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","tab-bar":"r42SvXKB","tabBar":"r42SvXKB","hide":"_2barvSul"};